import React from 'react';
import { Box } from '@chakra-ui/react';
import SmartRoutesTopActions from 'views/smart-routes/SmartRoutesTopActions';

export const SmartRouteLayout = ({
  children,
  topActionProps,
}: {
  children: React.ReactNode;
  topActionProps: any;
}) => {
  return (
    <>
      <Box position="sticky" top="0" zIndex="sticky" width="100%" bg="gray.100">
        <Box maxW="1700px" mx="auto" px={6}>
          <SmartRoutesTopActions {...topActionProps} />
        </Box>
      </Box>
      <Box maxW="1700px" mx="auto" px={6} pb="100px">
        {children}
      </Box>
    </>
  );
};
